// apps/web/src/features/kronos/timer/TimerContext.tsx
import { createContext, useContext, type ReactNode } from 'react';
import { useTimer, type TimerHookReturn } from './useTimer';

const TimerContext = createContext<TimerHookReturn | null>(null);

export function TimerProvider({ children }: { children: ReactNode }) {
  const timer = useTimer();
  return <TimerContext.Provider value={timer}>{children}</TimerContext.Provider>;
}

export function useTimerContext(): TimerHookReturn {
  const ctx = useContext(TimerContext);
  if (!ctx) {
    throw new Error('useTimerContext must be used within a TimerProvider');
  }
  return ctx;
}
